import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  Character, CharacterRoll, Modifier, Proficiency,
} from "@dndModels";
import { DisablableOption } from "@models";

import DataUtil from "@utilities/common_utilities";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import CharacterFeatureFromSource from "@dndComponents/character/features/CharacterFeatureFromSource";

const common_util = DataUtil.getInstance();

interface Props { 
  character: Character;
}

const prof_override_options: DisablableOption[] = [
  { id: "-1", text: "Don't Override", disabled: false, reason: "" },
  { id: "0", text: "Not Proficient", disabled: false, reason: "" },
  // { id: "0.5", text: "Half Proficiency", disabled: false, reason: "" },
  { id: "1", text: "Proficient", disabled: false, reason: "" },
  // { id: "2", text: "Expertise", disabled: false, reason: "" }
];

export default function CharacterSavingThrowInput({ 
  character,
}: Props) {
  const [customizing, setCustomizing] = useState(false);

  const renderASave = (type: string, value: CharacterRoll) => {
    return [
      <Grid
        key={type}
        size={{
          xs: 6
        }}>
        { type }
      </Grid>,
      <Grid
        key={`${type}_value`}
        size={{
          xs: 6
        }}>
        { common_util.addPlusMaybe(value.modifier) }
      </Grid>
    ];
  }

  const renderSaveCustomization = (ability_score: string, capitalized: string, customization_type: string) => {
    // const parent = character.saving_throw_customizations[ability_score];
    // const customization = parent ? parent[customization_type] : null;
    // return (
    //   <>
    //     <Grid
    //       size={{
    //         xs: customization && customization.value !== null ? 6 : 12
    //       }}>
    //       { customization_type === "Proficiency Override" ? 
    //         <SelectStringBox
    //           name={capitalized}
    //           options={prof_override_options}
    //           value={ customization && customization.value !== null ? `${customization.value}` : "-1" }
    //           onChange={(changed: string) => {
    //             if (!character.saving_throw_customizations[ability_score]) {
    //               character.saving_throw_customizations[ability_score] = { [customization_type]: { value: null, notes: "" }};
    //             } else if (!character.saving_throw_customizations[ability_score][customization_type]) {
    //               character.saving_throw_customizations[ability_score][customization_type] = { value: null, notes: "" };
    //             }
    //             if (changed === "-1") {
    //               delete character.saving_throw_customizations[ability_score][customization_type];
    //             } else {
    //               character.saving_throw_customizations[ability_score][customization_type].value = +changed;
    //             }
    //             character.subscription_holder.recalculate();
    //           }}
    //         />
    //       :
    //         <StringBox
    //           name={capitalized}
    //           value={ customization && customization.value !== null ? `${customization.value}` : "" }
    //           onBlur={(changed: string) => {
    //             if (!character.saving_throw_customizations[ability_score]) {
    //               character.saving_throw_customizations[ability_score] = { [customization_type]: { value: null, notes: "" }};
    //             } else if (!character.saving_throw_customizations[ability_score][customization_type]) {
    //               character.saving_throw_customizations[ability_score][customization_type] = { value: null, notes: "" };
    //             }
    //             if (changed === "") {
    //               delete character.saving_throw_customizations[ability_score][customization_type];
    //             } else {
    //               character.saving_throw_customizations[ability_score][customization_type].value = +changed;
    //             }
    //             character.subscription_holder.recalculate();
    //           }}
    //         />
    //       }
    //     </Grid>
    //     { customization && customization.value !== null &&
    //       <Grid
    //         size={{
    //           xs: 6
    //         }}>
    //         <StringBox
    //           name={ `Source/Notes` }
    //           value={ customization ? customization.notes : "" }
    //           onBlur={(changed: string) => {
    //             if (!character.saving_throw_customizations[ability_score]) {
    //               character.saving_throw_customizations[ability_score] = { [customization_type]: { value: null, notes: "" }};
    //             } else if (!character.saving_throw_customizations[ability_score][customization_type]) {
    //               character.saving_throw_customizations[ability_score][customization_type] = { value: null, notes: "" };
    //             }
    //             character.saving_throw_customizations[ability_score][customization_type].notes = changed;
    //             character.subscription_holder.recalculate();
    //           }}
    //         />
    //       </Grid>
    //     }
    //   </>
    // );
    return null;
  }

  const renderOther = () => {
    const saving_throw_profs = character.mind.proficiency_features.filter(cf => 
      cf.floating_feature instanceof Proficiency &&
      cf.floating_feature.proficiency_types.includes("Saving Throw"));
    const saving_throw_modifiers = character.mind.modifier_features.filter(cf => 
      cf.floating_feature instanceof Modifier && 
      ["Saving Throw"].includes(cf.floating_feature.modifies));
    const saving_throw_features = [...saving_throw_profs,...saving_throw_modifiers];
    return (
      <>
        <Grid
          style={{ 
            fontSize: "14px", 
            fontWeight: "bold",
            // cursor: "pointer"
          }}
          size={{
            xs: 12
          }}>
          Saving Throw Features
        </Grid>
        { saving_throw_features.sort((a,b) => { return a.name.localeCompare(b.name) }).map((char_feature, key) => {
          const source = character.char_feature_sources.find(o => 
            o.true_id === char_feature.source_true_id);
          if (source) {
            return (
              <CharacterFeatureFromSource key={key}
                character={character}
                obj={char_feature}
                source={source}
              />
            );
          }
          return null;
        })}
      </>
    );
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className="header centered"
        size={{
          xs: 12
        }}>
        Saving Throws
      </Grid>
      { renderASave("STR", character.mind.saving_throws.STR) }
      { renderASave("DEX", character.mind.saving_throws.DEX) }
      { renderASave("CON", character.mind.saving_throws.CON) }
      { renderASave("INT", character.mind.saving_throws.INT) }
      { renderASave("WIS", character.mind.saving_throws.WIS) }
      { renderASave("CHA", character.mind.saving_throws.CHA) }
      { renderOther() }
      <Grid
        size={{
          xs: 12
        }}>
        <ToggleButtonBox
          name="Customize"
          value={customizing}
          onToggle={() => {
            setCustomizing(!customizing);
          }}
        />
      </Grid>
      { customizing &&
        <>
          <Grid
            className="centered"
            size={{
              xs: 12
            }}>
            Override Saving Throw Proficiencies
          </Grid>
          { renderSaveCustomization("STR", "Strength", "Proficiency Override") }
          { renderSaveCustomization("DEX", "Dexterity", "Proficiency Override") }
          { renderSaveCustomization("CON", "Constitution", "Proficiency Override") }
          { renderSaveCustomization("INT", "Intelligence", "Proficiency Override") }
          { renderSaveCustomization("WIS", "Wisdom", "Proficiency Override") }
          { renderSaveCustomization("CHA", "Charisma", "Proficiency Override") }
          <Grid
            className="centered"
            size={{
              xs: 12
            }}>
            Modify Saving Throws
          </Grid>
          { renderSaveCustomization("STR", "Strength", "Modifier") }
          { renderSaveCustomization("DEX", "Dexterity", "Modifier") }
          { renderSaveCustomization("CON", "Constitution", "Modifier") }
          { renderSaveCustomization("INT", "Intelligence", "Modifier") }
          { renderSaveCustomization("WIS", "Wisdom", "Modifier") }
          { renderSaveCustomization("CHA", "Charisma", "Modifier") }
          <Grid
            className="centered"
            size={{
              xs: 12
            }}>
            Override Saving Throws
          </Grid>
          { renderSaveCustomization("STR", "Strength", "Override") }
          { renderSaveCustomization("DEX", "Dexterity", "Override") }
          { renderSaveCustomization("CON", "Constitution", "Override") }
          { renderSaveCustomization("INT", "Intelligence", "Override") }
          { renderSaveCustomization("WIS", "Wisdom", "Override") }
          { renderSaveCustomization("CHA", "Charisma", "Override") }
        </>
      }
    </Grid>
  );
}
